import $ from 'jquery/dist/jquery.min'

$('.js-accordion-trigger').click(function(e) {
  if ($(window).width() > 600) {
    return;
  }
  e.preventDefault();
  const $accordion = $(this).closest('.js-accordion');
  $accordion.find('.js-accordion-target').slideToggle();
  $accordion.toggleClass('js-accordion--open');
});



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/Accordion.jsx